import { getAirport } from "@utilize/Format";
import { ICmsAirport, IMedia, ITerminal } from "./CMS";

export interface IFlightPoint {
    id?: string;
    code?: string;
    cityName?: string;
    cityCode?: string;
    cityCover?: IMedia;
    countryCode?: string;
    airportName?: string;
    otherCityName?: string;
    otherAirportName?: string;
    otherTerminals?: ITerminal[];
    onlineCheckin?: boolean;
    latitude?: number;
    longitude?: number;
    terminals?: ITerminal[];
    forecaWeatherId?: number;
}

export class FlightPoint {
    private flightPoint: IFlightPoint = {};

    constructor(flightPoint: IFlightPoint) {
        if (flightPoint) {
            this.flightPoint = flightPoint;
            this.flightPoint.terminals = getAirport(flightPoint.code).terminals;
        }
    }

    // Todo return ITerminal
    public getDefaultTerminal(direction: string, otherSideAirportCode?: string): ITerminal | undefined {
        if (this.flightPoint.terminals) {
            const terminal = this.flightPoint.terminals.find(x => x.direction?.some(d => d === direction) && (x.defaultDestinations?.contentItems.some(x => x.code?.code === otherSideAirportCode)))
                || this.flightPoint.terminals.find(t => t.default && t.direction?.some(d => d === direction));
            return terminal;
        }
    }
}

export const mapCmsAirportToAirport = (airport: ICmsAirport, localizedAirport?: ICmsAirport[]): IFlightPoint => {
    const flightPoint: IFlightPoint = {
        airportName: airport.name,
        cityName: airport.city?.contentItems[0]?.name,
        cityCode: airport.city?.contentItems[0]?.code?.code,
        cityCover: airport.city?.contentItems[0]?.cover,
        onlineCheckin: (airport.onlineCheckinProfile?.contentItemIds?.length || 0) > 0,
        countryCode: airport.city?.contentItems[0]?.country?.contentItems[0]?.code?.code,
        code: airport.code?.code,
        latitude: airport.location?.latitude,
        longitude: airport.location?.longitude,
        terminals: airport.terminals?.contentItems,
        forecaWeatherId: airport.forecaWeatherId
    }
    localizedAirport?.forEach((locAirport) => {
        if (airport.code?.code === locAirport.code?.code) {
            flightPoint.otherAirportName = locAirport.name;
            flightPoint.otherCityName = locAirport.city?.contentItems[0]?.name;
            flightPoint.otherTerminals = locAirport.terminals?.contentItems;
        }
    })
    return flightPoint;
}